export default __webpack_public_path__ + "static/media/incubadora.f7f05fe8.png";